<span *ngIf="connectionStatus=='offline'" class="w-100 popover-body  bg-danger fixed-top text-white text-center offline " style="height: 24px;">{{connectionStatusMessage}}</span>
<span *ngIf="connectionStatus=='online'" class="w-100 popover-body  bg-success fixed-top text-white text-center  online" style="height: 24px;">{{connectionStatusMessage}}</span>

